import { createReducer } from 'store/utils';
import { RootActions } from 'store/types';
import { actionsHandlers, stateFactories } from 'store/features/utils';
import * as actions from '../actions';

const stateFactory = stateFactories.createInitialSingleFeatureStateFactory();
const initialState = stateFactory.getInitialState();

type State = typeof initialState;
type Actions = RootActions<typeof actions>;

const getVerificationCodeReducer = createReducer<State, Actions>(initialState, {
  [actions.getVerificationCode.request.type]: actionsHandlers.handleSingleFeatureRequest,
  [actions.getVerificationCode.success.type]: actionsHandlers.handleSingleFeatureSuccess,
  [actions.getVerificationCode.failure.type]: actionsHandlers.handleSingleFeatureFailure,
  [actions.getVerificationCode.reset.type]: actionsHandlers.handleSingleFeatureReset,
});

export default getVerificationCodeReducer;
